import { defineCrestModule } from './platform-module-manifest.contract.js';
import { platformPublicRequestGuardCapability } from '../capabilities/platform-capability.contract.js';
import { platformMyDayHostCapability } from '../hosts/platform-my-day-host.contract.js';
import { platformApprovedActionInvocationReceiptCapability, platformOptionalActionProviderHostCapability, platformReceiptBoundActionProviderHostCapability, } from '../hosts/platform-optional-action-provider-host.contract.js';
import { platformOptionalFactProviderHostCapability } from '../hosts/platform-optional-fact-provider-host.contract.js';
import { platformPortalHostCapability } from '../hosts/platform-portal-host.contract.js';
import { platformPortalAccessScopeProviderHostCapability } from '../hosts/platform-portal-access-scope-provider-host.contract.js';
import { platformStorageObjectReferenceCapability, platformStoragePublicResourceDelegationCapability, } from '../storage/platform-storage.contract.js';
import { platformStorageImportHandoffCapability } from '../storage/platform-storage-import-handoff.contract.js';
import { platformCurrentNotificationAudienceHoldCapability, platformInternalNotificationAudienceCapability, platformInternalNotificationAudienceV2Capability, platformInternalNotificationPermissionAudienceCapability, platformInternalNotificationRoleAudienceCapability, } from '../memberships/platform-internal-notification-audience.contract.js';
import { platformMediaAcquisitionCapability } from '../media-acquisition/platform-media-acquisition.contract.js';
import { platformImportResolutionCapability } from '../import-resolution/platform-import-resolution.contract.js';
export const platformModuleManifest = defineCrestModule({
    id: 'platform',
    version: '1.0.0',
    kind: 'platform',
    required: true,
    requires: [],
    requiredCapabilities: [],
    optionalCapabilities: [],
    optionalCapabilityFallbacks: [],
    provides: [
        'platform.runtime-bootstrap.v1',
        'platform.client-configuration-snapshot.v1',
        'platform.tenant-context.v1',
        'platform.request-authority-hold.v1',
        'platform.owner-invocation-receipts.v1',
        platformApprovedActionInvocationReceiptCapability,
        'platform.module-access.v1',
        'platform.membership-directory.v1',
        platformInternalNotificationAudienceCapability,
        platformInternalNotificationAudienceV2Capability,
        'platform.audit-writer.v1',
        'platform.transactional-outbox.v1',
        'platform.configuration-cache.v1',
        'platform.readiness.v1',
        platformPublicRequestGuardCapability,
        'platform.storage.v1',
        platformStorageImportHandoffCapability,
        platformMediaAcquisitionCapability,
        platformStorageObjectReferenceCapability,
        platformStoragePublicResourceDelegationCapability,
        'platform.configuration.v1',
        'platform.brand-assets.v1',
        'platform.custom-domains.v1',
        'platform.sender-identities.v1',
        'platform.module-archive.v1',
        platformMyDayHostCapability,
        platformOptionalActionProviderHostCapability,
        platformReceiptBoundActionProviderHostCapability,
        platformOptionalFactProviderHostCapability,
        platformPortalHostCapability,
        platformPortalAccessScopeProviderHostCapability,
        'platform.system-notifications.v1',
        'platform.system-notifications.enqueue.v1',
        platformCurrentNotificationAudienceHoldCapability,
        platformInternalNotificationRoleAudienceCapability,
        platformInternalNotificationPermissionAudienceCapability,
        'platform.migration-run-ledger.v1',
        platformImportResolutionCapability,
    ],
    permissions: [
        'platform.runtime.read',
        'platform.memberships.read',
        'platform.configuration.manage',
        'platform.configuration.publish',
        'platform.storage.use',
        'platform.migration.execute',
        'platform.migration.read',
        'platform.migration.rollback',
        'platform.brand-assets.manage',
        'platform.custom-domains.manage',
        'platform.custom-domains.verify',
        'platform.sender-identities.manage',
        'platform.sender-identities.verify',
        'platform.modules.archive',
        'platform.modules.reclaim',
        'platform.modules.destruction-request',
        'platform.system-notifications.read-own',
        'platform.system-notifications.operations.read',
    ],
    settings: [
        'platform.theme.tokens',
        'platform.branding.identity',
        'platform.custom-domains.selection',
        'platform.sender-identities.selection',
        'platform.layout.shell',
        'platform.accessibility.preferences',
        'platform.copy.my-day',
        'platform.system-notifications.configuration',
        'platform.system-notifications.display',
        'platform.copy.system-notifications',
    ],
    copyCatalogs: [
        'platform.copy.core',
        'platform.copy.my-day',
        'platform.copy.system-notifications',
    ],
    events: {
        publishes: [
            'platform.configuration-published.v1',
            'platform.configuration-rollback-published.v1',
            'platform.brand-asset-verified.v1',
            'platform.brand-asset-state-changed.v1',
            'platform.custom-domain-verified.v1',
            'platform.custom-domain-state-changed.v1',
            'platform.sender-identity-verified.v1',
            'platform.sender-identity-state-changed.v1',
            'platform.system-notification-requested.v1',
        ],
        subscribes: [
            'platform.configuration-published.v1',
            'platform.configuration-rollback-published.v1',
            'platform.system-notification-requested.v1',
        ],
    },
    server: {
        routes: [
            { id: 'platform.routes.runtime-bootstrap', priority: 0 },
            { id: 'platform.routes.configuration', priority: 10 },
            { id: 'platform.routes.health', priority: 20 },
            { id: 'platform.routes.memberships', priority: 30 },
            { id: 'platform.routes.brand-assets', priority: 40 },
            { id: 'platform.routes.custom-domains', priority: 50 },
            { id: 'platform.routes.sender-identities', priority: 60 },
            { id: 'platform.routes.system-notifications', priority: 70 },
        ],
        jobs: [{
                id: 'platform.jobs.outbox-delivery',
                requiredCapability: 'platform.transactional-outbox.v1',
                priority: 0,
            }],
        subscribers: [{
                id: 'platform.subscribers.configuration-cache-invalidation',
                requiredCapability: 'platform.configuration-cache.v1',
                priority: 0,
            }, {
                id: 'platform.subscribers.system-notification-requested',
                requiredCapability: 'platform.system-notifications.enqueue.v1',
                priority: 10,
            }],
        slots: [],
    },
    web: {
        routes: [{ id: 'platform.web.my-day', priority: 0 }],
        navigation: [{ id: 'platform.navigation.my-day', priority: 0 }],
        slots: [
            { id: 'platform.web.settings.theme-tokens', priority: 0 },
            { id: 'platform.web.settings.branding-identity', priority: 10 },
            { id: 'platform.web.settings.custom-domains', priority: 20 },
            { id: 'platform.web.settings.sender-identities', priority: 30 },
            { id: 'platform.web.settings.shell-layout', priority: 40 },
            { id: 'platform.web.settings.accessibility-preferences', priority: 50 },
            { id: 'platform.web.settings.core-copy', priority: 60 },
            { id: 'platform.web.settings.my-day-copy', priority: 70 },
            { id: 'platform.web.settings.system-notification-configuration', priority: 80 },
            { id: 'platform.web.settings.system-notification-display', priority: 90 },
            { id: 'platform.web.settings.system-notification-copy', priority: 100 },
        ],
    },
    mobile: { routes: [], slots: [] },
    portal: { routes: [], slots: [] },
    database: {
        schema: 'platform',
        owns: [
            'platform.tenants',
            'platform.user_accounts',
            'platform.tenant_memberships',
            'platform.tenant_roles',
            'platform.tenant_role_permissions',
            'platform.tenant_membership_roles',
            'platform.tenant_membership_permission_overrides',
            'platform.lock_current_request_authority_v1',
            'platform.lock_active_tenant_membership_v1',
            'platform.lock_role_authorization_graph_write_statement_v1',
            'platform.owner_invocation_receipts',
            'platform.guard_owner_invocation_receipt_mutation_v1',
            'platform.issue_owner_invocation_receipt_v1',
            'platform.lock_owner_invocation_receipt_v1',
            'platform.consume_owner_invocation_receipt_v1',
            'platform.lock_current_approved_action_authority_v1',
            'platform.approved_action_invocation_receipts',
            'platform.guard_approved_action_invocation_receipt_mutation_v1',
            'platform.issue_approved_action_invocation_receipt_v1',
            'platform.lock_approved_action_invocation_receipt_v1',
            'platform.consume_approved_action_invocation_receipt_v1',
            'platform.assert_approved_action_invocation_receipt_consumed_v1',
            'platform.has_current_approved_action_invocation_receipt_v1',
            'platform.resolve_internal_notification_audience_v1',
            'platform.resolve_internal_notification_audience_v2',
            'platform.tenant_module_states',
            'platform.audit_events',
            'platform.domain_event_outbox',
            'platform.tenant_configuration_drafts',
            'platform.tenant_configuration_releases',
            'platform.tenant_configuration_previews',
            'platform.tenant_configuration_events',
            'platform.storage_objects',
            'platform.storage_upload_intents',
            'platform.storage_import_handoff_commands',
            'platform.storage_import_handoff_receipts',
            'platform.storage_import_handoff_assert_runtime_v1',
            'platform.storage_import_handoff_receipt_body_v1',
            'platform.storage_import_handoff_receipt_id_v1',
            'platform.storage_import_handoff_receipt_json_v1',
            'platform.begin_storage_import_handoff_v1',
            'platform.record_storage_import_handoff_verified_v1',
            'platform.get_storage_import_handoff_receipt_v1',
            'platform.verify_storage_import_handoff_receipt_v1',
            'platform.reject_storage_import_handoff_evidence_mutation_v1',
            'platform.storage_public_resource_delegations',
            'platform.create_public_storage_upload_intent_v1',
            'platform.record_public_storage_upload_authorization_v1',
            'platform.begin_public_storage_upload_verification_v1',
            'platform.complete_public_storage_upload_verification_v1',
            'platform.mark_public_storage_upload_attached_v1',
            'platform.mark_public_storage_object_deleted_v1',
            'platform.current_attached_storage_object_matches',
            'platform.current_attached_storage_object_facts',
            'platform.brand_assets',
            'platform.custom_domain_claims',
            'platform.custom_domains',
            'platform.sender_identity_claims',
            'platform.sender_identities',
            'platform.module_archive_tombstones',
            'platform.module_archive_reclaims',
            'platform.module_archive_destruction_requests',
            'platform.module_archive_destruction_authorizations',
            'platform.system_notification_requests',
            'platform.system_notification_entries',
            'platform.system_notification_read_commands',
            'platform.system_notification_reads',
            'platform.reject_system_notification_mutation',
            'platform.enqueue_system_notification_request_v1',
            'platform.consume_system_notification_requested_v1',
            'platform.list_current_system_notifications_v1',
            'platform.count_current_system_notifications_v1',
            'platform.mark_system_notification_read_v1',
            'platform.mark_all_system_notifications_read_v1',
            'platform.system_notification_materializer_health_v1',
            'platform.hold_current_notification_audience_context_v1',
            'platform.filter_and_hold_active_notification_memberships_v1',
            'platform.resolve_and_hold_internal_notification_audience_v3',
            'platform.resolve_and_hold_internal_notification_role_audience_v1',
            'platform.resolve_and_hold_internal_notification_permission_audience_v1',
            'platform.migration_runs',
            'platform.migration_owner_receipts',
            'platform.reject_migration_owner_receipt_mutation_v1',
            'platform.get_migration_run_record_v1',
            'platform.reserve_migration_run_v1',
            'platform.lock_migration_run_writable_v1',
            'platform.save_migration_run_v1',
            'platform.import_target_identity_map',
            'platform.import_target_changes',
            'platform.import_target_change_rollbacks',
            'platform.import_target_bootstraps',
            'platform.import_target_bootstrap_bindings',
            'platform.import_target_bootstrap_rollbacks',
            'platform.import_target_evidence_immutable',
            'platform.import_canonical_json',
            'platform.import_sha256',
            'platform.import_timestamp_text',
            'platform.import_payload_has_exact_keys',
            'platform.import_target_canonical',
            'platform.import_validate_target_payload',
            'platform.import_expected_canonical',
            'platform.restore_import_target_v1',
            'platform.apply_import_target_v1',
            'platform.rollback_import_target_v1',
            'platform.bootstrap_import_target_v1',
            'platform.bootstrap_import_target_unbound_v1',
            'platform.import_target_bootstrap_rollback_json_v1',
            'platform.import_target_bootstrap_state_sha256_v1',
            'platform.rollback_import_target_bootstrap_v1',
            'platform.verify_import_resolution_v1',
            'platform.operational_history_import_runs',
            'platform.operational_history_import_rejects',
            'platform.operational_history_import_changes',
            'platform.begin_operational_history_import_v1',
            'platform.quarantine_operational_history_import_v1',
            'platform.complete_operational_history_import_v1',
            'platform.fail_operational_history_import_v1',
            'platform.rollback_operational_history_import_v1',
        ],
        readsThrough: [],
        migrations: [
            'platform.projects_foundation',
            'platform.configuration_releases',
            'platform.configuration_updated_at_grant',
            'platform.configuration_release_controls',
            'platform.audit_outbox_foundation',
            'platform.membership_directory',
            'platform.projects_storage_foundation',
            'platform.storage_object_reference',
            'platform.storage_object_facts',
            'platform.storage-import-handoff',
            'platform.public_storage_delegations',
            'platform.brand_assets_custom_domains_sender_identities',
            'platform.outbox_delivery_worker',
            'platform.runtime_access_revisions',
            'platform.internal-notification-audience',
            'platform.owner-invocation-receipts',
            'platform.approved-action-invocation-receipts',
            'platform.internal-notification-audience-v2',
            'platform.module-archive-tombstones',
            'platform.role-authorization-serialization',
            'platform.role-authorization-cross-tenant-roots',
            'platform.request-authority-and-role-graph-statement-fence',
            'platform.active-membership-target-lock',
            'platform.system-notification-feed',
            'platform.current-notification-audience-hold',
            'platform.internal-notification-role-audience',
            'platform.internal-notification-permission-audience',
            'platform.crm2-migration-run-ledger',
            'platform.migration-run-writable-hold',
            'platform.import-target-writes',
            'platform.import-bootstrap-rollback',
            'platform.import-resolution',
            'platform.operational-history-import',
        ],
    },
    health: ['platform.database', 'platform.outbox', 'platform.system-notifications'],
    lifecycle: {
        initialization: { timeoutMs: 10_000, failureBehavior: 'reject-release' },
        resources: {
            requestConcurrency: 256,
            jobConcurrency: 32,
            queueBacklogLimit: 100_000,
            databaseConnectionBudget: 64,
            workerIsolation: 'separate-worker',
        },
        disable: {
            data: 'retain',
            clientContributions: 'remove',
            serverRoutes: 'deny-tenant-access',
            scheduledJobs: 'bounded-catch-up',
            events: {
                behavior: 'pause-and-replay',
                durableCursor: true,
                retentionDays: 30,
                backlogLimit: 100_000,
                warningAt: 80_000,
                reconciliationProcedure: 'platform.resume.reconcile-outbox.v1',
                dropSafeReason: null,
            },
            outboundSideEffects: 'suppress-no-retroactive-send',
            inFlight: 'fence-and-retry',
        },
        resume: {
            configuration: 'last-compatible-published',
            healthChecks: ['platform.database', 'platform.outbox'],
            reconciliationProcedure: 'platform.resume.reconcile-outbox.v1',
            visibility: 'after-health-and-reconciliation',
        },
        uninstall: {
            executableCode: 'remove',
            data: 'retain',
            tombstone: 'retain-immutable',
            destruction: 'separate-explicit-authority',
        },
    },
    retentionPolicy: 'Platform records follow the approved tenant and audit retention policy.',
});
//# sourceMappingURL=platform.module.js.map